let errorCounter: {lastAttemptNumber: number, lastError: number} | null = null;

export function incrementErrorCount() {
  errorCounter = { lastAttemptNumber: (errorCounter?.lastAttemptNumber || 0) + 1, lastError: Date.now() };
}

export function clear() {
  errorCounter = null;
}

export function check() : number | null {
  if (errorCounter === null) {
    return null;
  }
  const minDate = errorCounter.lastError + Math.min(2 ** errorCounter.lastAttemptNumber * 1000, 60000);
  if (minDate < Date.now()) {
    return null;
  }
  return minDate - Date.now();
}
